import { Kitchen, KitchenRounded, LayersOutlined, Person, PhoneAndroid, PrintRounded } from '@mui/icons-material';
import CategoryIcon from '@mui/icons-material/Category';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import QueryStatsIcon from '@mui/icons-material/QueryStats';

export const sidebarUrls: {
    [key: string]: { url: string; icon: JSX.Element; name: string };
} = {
    Dashboard: {
        url: '/app/dashboard',
        name: 'Dashboard',
        icon: <DashboardIcon sx={{ fontSize: 30 }} />,
    },
    Order: {
        url: '/app/counter',
        name: 'Order',
        icon: <ShoppingBasketIcon sx={{ fontSize: 30 }} />,
    },
    OrderHistory: {
        url: '/app/history',
        name: 'History',
        icon: <ReceiptLongIcon sx={{ fontSize: 30 }} />,
    },
    Kitchen: {
        url: '/app/kitchen',
        name: 'Kitchen',
        icon: <Kitchen sx={{ fontSize: 30 }} />,
    },
    KitchenStats: {
        url: '/app/kitchen-stats',
        name: 'Kitchen Stats',
        icon: <QueryStatsIcon sx={{ fontSize: 30 }} />,
    },
    Inventory: {
        url: '/app/inventory',
        name: 'Inventory',
        icon: <InventoryIcon sx={{ fontSize: 30 }} />,
    },
    Category: {
        url: '/app/category',
        name: 'Category',
        icon: <CategoryIcon sx={{ fontSize: 30 }} />,
    },
    Settings: {
        url: '/app/settings',
        name: 'Settings',
        icon: <SettingsIcon sx={{ fontSize: 30 }} />,
    },
    Users: {
        url: '/app/users',
        name: 'Users',
        icon: <Person sx={{ fontSize: 30 }} />,
    },
    Layout: {
        url: '/app/layout',
        name: 'Layout',
        icon: <LayersOutlined sx={{ fontSize: 30 }} />,
    },

    // AdminKitchen: {
    //     url: '/app/admin-kitchen',
    //     name: 'Admin Kitchen',
    //     icon: <KitchenRounded sx={{ fontSize: 30 }} />,
    // },
    AppDownload: {
        url: '/app/download',
        name: 'App Download',
        icon: <PhoneAndroid sx={{ fontSize: 30 }} />,
    }

};


export const sidebarExtraUrls: {
    [key: string]: { url: string; icon: JSX.Element; name: string };
} = {
    Printer: {
        url: '/app/printer',
        name: 'Printer',
        icon: <PrintRounded sx={{ fontSize: 30 }} />,
    }

};
